module.exports = __webpack_public_path__ + "static/media/title_head.8781a916.svg";